export enum QUERY_KEYS {
  CADS = 'CADS',
  CAD = 'CAD',
  PAGE_CAD = 'PAGE:CAD',
  CAD_ASSEMBLY_TREE = 'CAD:ASSEMBLY_TREE',
  GLTF = 'GLTF',
}

export default QUERY_KEYS
